import { create } from 'zustand';

export const useUiStore = create((set, get) => ({
    loadingCount: 0,
    loading: false,
    startLoading: () => {
        const next = get().loadingCount + 1;
        set({ loadingCount: next, loading: next > 0 });
    },
    stopLoading: () => {
        const next = Math.max(0, get().loadingCount - 1);
        set({ loadingCount: next, loading: next > 0 });
    },
    resetLoading: () => set({ loadingCount: 0, loading: false }),
}));
